<!--
@author Muhammed T Javed
@date 03/06/2018
-m will show the main user profile page
-->

<style scoped>

.profileContainer{
     min-height: 500px;
     border-radius: 5px;
    
}
.profileTop{
    min-height:200px;
    background: #00B9FF;
    display: flex;
    align-items: center;
    color:white;
    text-align: center;
    font-family: 'Roboto', sans-serif;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    font-family: 'Roboto', sans-serif;
    border-radius: 2px;
    margin-top:20px;
  

}
.profileImagecircleContainer{
     position: relative;
     height: 350px;
    width:350px;
    border-radius: 50%;
     display: flex;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    background: black;
    color:white;
    top:-50px;
    box-shadow: 5px 5px 5px #D35B5B;
    transform: rotate(0deg);
        box-shadow: -5px 10px 5px 2px white;

        
}

.center{
    display: flex;
    align-items: center;
    justify-content: center;
    background:#00B9FF;

    
}
.detailsContainer{
    min-height: 500px;
}

.detailsNav{
    display: flex;
    justify-content: space-around;
    font-size: 20px;
    font-family: 'Roboto', sans-serif;
    background:#00B9FF;
    padding:20px;
    color:white;
    position: relative;
    top:-40px;
}



.detailsNavItem{
    transition: all .2s;
}
.detailsNavItem:hover{
    cursor:pointer;
    color:black;
}
.profileContentContainer{
    min-height:1000px;
}
.active{
    background:black;
    padding: 10px;
    border-radius: 5px;
    transition: all .4s;
}
.active:hover{
    background: white;
}
@media screen and (min-width: 800px) {
    .stickyNav{
    position: fixed;
    top:0px;
    width: 50%;
    right:0px;
    opacity: 1;
    z-index: 10;
    height: 70px;
    margin-bottom: 400px;
}
.stickyNav:hover{
    opacity: 1;
}
.detailsNavItem{
     height: 40px;
}
    
}
@media only screen and (max-width:800px){
    .profileImagecircleContainer{
        width:100px;
        height: 100px;;
    }
    .detailsNav{
        flex-flow: column;
        justify-content: center;
        align-items: center;
    }
    .detailsNavItem{
        margin-top: 10px;
        
    }

 

     
    
}
 
</style>

<template>
<div class="profileContainer">

<div class="profileTop">
    {{email}}
    
</div>
<div class="center">
    <div class="profileImagecircleContainer">
        <img height="100%" width="100%" style="border-radius:50%" :src="profilePicture"/>
    </div>
</div>
<!-- container for profile image ends here-->

<div class="detailsContainer">
    <div id="stickyProfileNavBar" v-bind:class="{stickyNav:navState.isProfileNavSticky}" class="detailsNav">
        <div v-bind:class="{active:profileNavState.isBreifSelected}" @click="goToNavLink('breif')" class="detailsNavItem">Brief info</div>
        <!-- <div v-bind:class="{active:profileNavState.isEductationSelected}" @click="goToNavLink('education')" class="detailsNavItem">Education</div> -->
        <div v-bind:class="{active:profileNavState.isInterestsSelected}" @click="goToNavLink('messages')" class="detailsNavItem">Messages Centre</div>
        <!-- <div v-bind:class="{active:profileNavState.isFriendsSelected}" @click="goToNavLink('interests')" class="detailsNavItem">Interests/Prefs</div> -->
        <div v-bind:class="{active:profileNavState.isFolloweresSelected}"@click="goToNavLink('followers')" class="detailsNavItem">Friends/Followers</div>
    </div>
    <div class="profileContentContainer">
        <component :is="profileCurrentContent" ></component>
    </div>
</div>

  
</div>

</template>

<script>

import breifInfo from './components/breifinfo';
import education from './components/education';
import followers from './components/followers';
import interests from './components/interests';
import messages from './components/messages';
//importing profile components above

export default{
    data:function(){
        return {
            navState:{
                isProfileNavSticky:false
            },
            profileNavState:{
                //im sure their is a better way of doing this but whatever for now its fine
                isBreifSelected:true,
                isEductationSelected:false,
                isInterestsSelected:false,
                isFriendsSelected:false,
                isFolloweresSelected:false
            },
            profileCurrentContent:'breifInfo'
        }
    },components:{
        breifInfo,
        education,
        followers,
        interests,
        messages
    },methods:{
        handleScroll(){
            //handles scroll to attach sticky nav
            let home= this;
            //console.log("scrolling"+window.scrollY);
            let offsetTop= document.getElementById("stickyProfileNavBar").offsetTop;
            if(window.scrollY>750){
                home.navState.isProfileNavSticky=true;
            }else{
               // console.log("make non-stiky");
                home.navState.isProfileNavSticky=false;
            }
        },
        resetProfileNavState(){
            //method will reset profileNavState to false
            let ref= this.profileNavState;
            ref.isBreifSelected=false;
            ref.isEductationSelected=false;
            ref.isInterestsSelected=false;
            ref.isFriendsSelected=false;
            ref.isFolloweresSelected=false;
        },goToNavLink(to){
            let ref= this.profileNavState;
            //method will be called switch between profile components
            var home=this;
            this.resetProfileNavState();
            //reset all positions

            switch(to){
                case "breif":
                 ref.isBreifSelected=true;
                 home.profileCurrentContent="breifInfo";
                 home.$router.push("/profile/breifinfo");
                break;
                case "education":
                ref.isEductationSelected=true;
                home.profileCurrentContent="education";
                break;
                case "messages":
                ref.isInterestsSelected=true;
                home.profileCurrentContent="messages";
                home.$router.push("/profile/messages");
                break;
                case "interests":
                ref.isFriendsSelected=true;
                home.profileCurrentContent="interests";
                break;
                case "followers":
                ref.isFolloweresSelected=true;
                home.profileCurrentContent="followers";
                home.$router.push("/profile/friends");
                break;
            }
        }
    },created(){
        //add an event listener to listen for the scroll event passed by the dom
        //window.addEventListener('scroll',this.handleScroll);

         
     },computed:{
        email(){
            return  this.$store.state.authRelated.loginDetails.profileMeta.email;
        },
        profilePicture(){
            //determine if user has a profile picture if not we will supply a generic one
            if(this.$store.state.authRelated.loginDetails.optionalAdditionalData.profileImage){
                return this.$store.state.authRelated.loginDetails.optionalAdditionalData.profileImage;
            }else{
                //return a generic image
                return "https://firebasestorage.googleapis.com/v0/b/social-station-69cfc.appspot.com/o/web%2Fdefault%20image%2FPlaceholder.png?alt=media&token=b5d9d748-e2aa-4354-a331-adfc1cfcac15";
            }
        }
    },mounted(){
        console.log("---");
        var pageToGoTo= this.$route.params.page;

        switch(pageToGoTo){
            case "breif-info":
            this.goToNavLink("breif");
            break;
            case "messages":
            this.goToNavLink("messages");
            break;
            case "friends":
            this.goToNavLink("followers");
            break;
        }
        

    }
}

</script>






// WEBPACK FOOTER //
// src/assets/Dynamic/_mainDirectives/myprofile/main.vue